import React, { Component } from 'react';
import Script from 'react-load-script';
import _ from 'lodash';

import { GOOGLE_MAP_URL } from '../../constants/defaults';

class GoogleMap extends Component {
  static defaultProps = {
    isMarkerShown : true,
    center : {
      lat: -25.344,
      lng: 131.036
    },
    zoom : 14,
    containerElement : {},
    mapElement : {}
  }

  constructor(props) {
    super(props);

    this.handleScriptLoad = this.handleScriptLoad.bind(this);
  }

  componentDidUpdate(oldProps) {
    if (!_.isEqual(this.props, oldProps)) {
      this.deleteDomNode();
      this.loadGoogleMap();
    }
  }

  handleScriptLoad() {
    if (window.google) {
      this.loadGoogleMap();
    }
  }

  deleteDomNode() {
    try {
      const map = document.getElementById("Gmap");

      while (map.firstChild) {
        map.removeChild(map.firstChild);
      }
    } catch(e) {
      console.error(`[component:GoogleMap][method:deleteDomNode] Unexpected error occured : ${e}`);
    }
  }

  loadGoogleMap() {
    try {
      const map = new window.google.maps.Map(document.getElementById('Gmap'), {
        center: this.props.center,
        zoom: this.props.zoom
      });
  
      if (this.props.isMarkerShown) {
        new window.google.maps.Marker({
          position: this.props.center,
          map
        });
      }
    } catch(e) {
      console.error(`[component:GoogleMap][method:LoadGoogleMap] Unexpected error occured : ${e}`);
    }
  }

  render() {
    return (
      <div style={this.props.containerElement}>
        <Script
          url={GOOGLE_MAP_URL}
          onLoad={this.handleScriptLoad}
        />
        <div id="Gmap" style={this.props.mapElement} />
      </div>
    )
  }
}

export default GoogleMap;



// WEBPACK FOOTER //
// ./src/containers/components/GoogleMap.js